import { getJobsListingRoute, jobPositionsKey } from '@features/hireflixJob';
import axiosInstance from '@server/axiosInstance';
import { useQuery } from 'react-query';

interface UseGetJobPositionsParams {
  created_list?: boolean;
}

export const useGetJobPositions = ({
  created_list,
}: UseGetJobPositionsParams = {}) => {
  const {
    data: jobPositionsData,
    isLoading: isLoadingJobPositions,
    isError: isErrorJobPositions,
    isFetched: isFetchedJobPositions,
  } = useQuery({
    queryKey: [jobPositionsKey, created_list],
    queryFn: () =>
      axiosInstance
        .get(getJobsListingRoute, {
          params: {
            created_list,
          },
        })
        .then((res) => res.data),
    refetchOnWindowFocus: false,
  });

  return {
    jobPositionsData,
    isLoadingJobPositions,
    isErrorJobPositions,
    isFetchedJobPositions,
  };
};
